export enum ShippingLabelStep {
  None = 'None',
  Validation = 'Validation',
  SelectWarehouse = 'SelectOrderWarehouse',
  OrderWithoutAutomatizaion = 'OrderWithoutAutomatizaion',
  OrderLabelPrint = 'OrderLabelPrint',
  Close = 'Close',
}
